export class TrainingItemGroupSearchCriteria{
    searchText?: string;
    eQMSScopes?: number[];
}